import jwtDecode from 'jwt-decode';
import config from '../../../../config';

export const appendQueryParam = (queryString, paramName, paramValue) => {
  let result = queryString;
  if (paramName && paramValue) {
    if (queryString.length) {
      result = `${queryString}&${paramName}=${paramValue}`;
    } else {
      result = `?${paramName}=${paramValue}`;
    }
  }
  return result;
};

export class ApiError extends Error {
  constructor(m, data, status, desc) {
    super(m);

    this.data = data;
    this.status = status;
    this.desc = desc;
  }
}

export const genericHandleApiError = (response) => {
  return response.json().then((data) => {
    /* eslint-disable no-console */
    console.log('API Error', response);
    console.log('Data', data);
    /* eslint-enable no-console */
    throw new ApiError('Api Error', data, response.status, null);
  });
};

export const decodeJwt = (data) => {
  const decodedToken = jwtDecode(data.accessToken);
  const decodedRefreshToken = jwtDecode(data.refreshToken);
  const decodedResponse = {
    name: decodedToken.name,
    accessToken: data.accessToken,
    decodedToken,
    refreshToken: data.refreshToken,
    _links: data._links,
    decodedRefreshToken,
  };
  return decodedResponse;
};

export const setToken = (headers, token) => {
  headers.set('Authorization', `Bearer ${token}`);
};

export const setupJsonHeaders = () => {
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Accept', 'application/json');
  myHeaders.append('apikey', config.apikey);
  return myHeaders;
};

export const setupJsonStreamHeaders = () => {
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Accept', 'application/x-ndjson');
  myHeaders.append('apikey', config.apikey);
  return myHeaders;
};

export const setupPdfJWTHeaders = (token) => {
  const myHeaders = new Headers();
  myHeaders.append('Accept', 'application/pdf,application/json');
  myHeaders.append('apikey', config.apikey);
  setToken(myHeaders, token);
  return myHeaders;
};

export const setupJsonJWTHeaders = (token) => {
  const myHeaders = setupJsonHeaders();
  setToken(myHeaders, token);
  return myHeaders;
};

export const setupJsonStreamJWTHeaders = (token) => {
  const myHeaders = setupJsonStreamHeaders();
  if (token) {
    setToken(myHeaders, token);
  }
  return myHeaders;
};

export const setupAcceptLanguageHeader = (token, acceptLanguage) => {
  const headers = setupJsonJWTHeaders(token);
  headers.append('Accept-Language', acceptLanguage);
  return headers;
};

export const requestOk = (response) => {
  return response.status >= 200 && response.status < 300;
};
